import { useTheme, Box } from '@mui/material'
import { Bar } from 'react-chartjs-2'
import { useTranslation } from 'react-i18next'
import { useAppSelector } from '../../store/hooks'
import { fsColors } from '../../shared/constants'

const ChartKPIF = ({ results, height = 550 }: { results: any; height?: number }) => {
  const theme = useTheme()
  const { t } = useTranslation()
  const { currentLanguage } = useAppSelector((state) => state.currentUser)

  return (
    <Box pb={2} mt={-2.5} height={height}>
      <Bar
        className="variable_mean_pay_gap"
        id="variable_mean_pay_gap"
        data={{
          labels: results.map((rrr: any, index: number) => {
            const l = [`${t(rrr.label.text)}`]
            if (index === 3) l.push(t('lowest.quartile'))
            else if (index === 0) l.push(t('highest.quartile'))
            return l
          }),
          datasets: [
            {
              label: t(results[0].value[0].label),
              data: results.map((rrr: any) => rrr.value[0].value),
              backgroundColor: fsColors.fsPurple.colors[0],
              stack: 'total',
              barThickness: 35,
            },
            {
              label: t(results[0].value[1].label),
              data: results.map((rrr: any) => rrr.value[1].value),
              backgroundColor: fsColors.fsGray.colors[1],
              stack: 'total',
              barThickness: 35,
            },
          ],
        }}
        options={{
          maintainAspectRatio: false,
          indexAxis: 'y',
          layout: {
            padding: {
              top: 0,
              right: 50,
              left: 25,
            },
          },
          plugins: {
            // @ts-ignore
            legendMargin: false,
            legend: {
              display: true,
              labels: {
                padding: 70,
              },
              onHover: (e: any) => {
                e.native.target.style.cursor = 'pointer'
              },
              onLeave: (e: any) => {
                e.native.target.style.cursor = 'default'
              },
            },
            tooltip: {
              enabled: true,
              callbacks: {
                title: (context) => context[0].label.replace(',', ', '),
                label: (context) => {
                  return `${t('proportion.of')} ${
                    context.dataset.label
                    // @ts-ignore
                  }: ${context.raw.toLocaleString(currentLanguage, {
                    maximumFractionDigits: 2,
                  })} %`
                },
              },
            },
            datalabels: {
              anchor: 'center',
              align: 'bottom',
              padding: 18,
              color: theme.palette.text.primary,
              formatter: (value) =>
                `${Number(value).toLocaleString(currentLanguage, {
                  maximumFractionDigits: 2,
                })} %`,
            },
          },
          scales: {
            x: {
              display: false,
            },
            xBottom: {
              type: 'linear',
              offset: true,
              min: 0,
              max: 100,
              grid: {
                display: true,
                color: theme.palette.divider,
              },
              border: {
                color: theme.palette.text.disabled,
              },
              ticks: {
                autoSkip: true,
                stepSize: 10,
                maxTicksLimit: 8,
                color: theme.palette.text.secondary,
                callback: (value) =>
                  `${Number(value).toLocaleString(currentLanguage, {
                    maximumFractionDigits: 2,
                  })} %`,
              },
            },
            y: {
              grid: {
                display: false,
              },
              border: {
                display: false,
              },
              ticks: {
                color: theme.palette.text.primary,
                padding: 20,
                font: {
                  weight: 'bold',
                  lineHeight: 1.7,
                },
              },
              offset: true,
              type: 'category',
            },
          },
        }}
      />
    </Box>
  )
}

export default ChartKPIF
